import React from 'react';

import { CONSTANTS } from '../../../core/config/constants';
import { ColumnPresetContextProvider } from '../shared/ColumnPresetContext/ColumnPresetContext';
import { FilterContextProvider } from '../shared/FinancialDataContext/FinancialDataContext';
import CompanyPage from './CompanyPage';

interface OwnProps {
  path: string;
}

const CompanyPageWrapper: React.FC<OwnProps> = ({ path }) => {
  return (
    <FilterContextProvider
      version={CONSTANTS.COMPANIES_FILTER_STORAGE.VERSION}
      storageKey={CONSTANTS.COMPANIES_FILTER_STORAGE.KEY}
    >
      <ColumnPresetContextProvider>
        <CompanyPage path={path} />
      </ColumnPresetContextProvider>
    </FilterContextProvider>
  );
};

export default CompanyPageWrapper;
